import { ready } from '~/core';
import { addEvents } from '~/utils';

ready('filters', '.filters-group', group => {
	const toggle = group.querySelector('.filters-category');
	const filters = group.querySelector('.filters-filters');

	const do_toggle = () => {
		let start, end;

		start = filters.offsetHeight;
		group.classList.toggle('is-open');
		end = filters.offsetHeight;

		filters.animate([{ height: `${start}px` }, { height: `${end}px` }], {
			duration: 250,
			easing: 'ease',
		});
	};

	addEvents(toggle, 'click.self.prevent', do_toggle)
	addEvents(toggle, 'keyup', function(e) {
		if(e.keyCode === 32 || e.keyCode === 13) {
			e.preventDefault();
			do_toggle();
		}
	})
});
